import { Controller } from 'front-end-core/core/Router'
import Main from 'pages/currentawarenessarticle/Main'
import getUrl from 'front-end-core/core/url'
import { CURRENT_AWARENESS_ARTICLE } from 'constants/controllers'

export default new Controller({
  name: CURRENT_AWARENESS_ARTICLE,
  route: ':aol/article(/id/:id)',
  controller (Router, { url, pageView, pageData, params }, render) {
    const { aol, id = null } = params
    const bottleLink = () => getUrl(CURRENT_AWARENESS_ARTICLE, { aol })
    const pageId = id ? url : getUrl(CURRENT_AWARENESS_ARTICLE, { aol })

    render(
      {
        Main
      },
      { id, aol },
      {
        aol,
        pageId,
        bottleLink,
        className: 'article',
        name: CURRENT_AWARENESS_ARTICLE,
        pageView,
        feedbackOptions: ['article'],
        searchType: 'ca'
      }
    )

    return pageId
  }
})
